/*
  PDP sections — shared scripts
  1. <pdp-carousel>: scroll-snap carousel with prev/next buttons (pdp-testimonials)
  2. [data-pdp-scroll-to-buy]: buttons with no link scroll up to the product form
*/

if (!customElements.get('pdp-carousel')) {
  class PdpCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pdp-carousel__track');
      this.prev = this.querySelector('.pdp-carousel__button--prev');
      this.next = this.querySelector('.pdp-carousel__button--next');
      if (!this.track) return;

      this.onScroll = this.update.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      if (this.prev) this.prev.addEventListener('click', () => this.move(-1));
      if (this.next) this.next.addEventListener('click', () => this.move(1));

      this.update();
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    slideStep() {
      const slide = this.track.querySelector('.pdp-carousel__slide');
      if (!slide) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    move(direction) {
      this.track.scrollBy({ left: direction * this.slideStep(), behavior: 'smooth' });
    }

    update() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const scrollable = maxScroll > 2;
      this.classList.toggle('pdp-carousel--centered', !scrollable);
      if (this.prev) {
        this.prev.hidden = !scrollable;
        this.prev.disabled = this.track.scrollLeft <= 2;
      }
      if (this.next) {
        this.next.hidden = !scrollable;
        this.next.disabled = this.track.scrollLeft >= maxScroll - 2;
      }
    }
  }

  customElements.define('pdp-carousel', PdpCarousel);
}

if (!window.pdpScrollToBuyBound) {
  window.pdpScrollToBuyBound = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-pdp-scroll-to-buy]');
    if (!trigger) return;

    const form =
      document.querySelector('product-info form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    event.preventDefault();
    const target = form.closest('product-info') || form;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    const submit = form.querySelector('[type="submit"]');
    if (submit) {
      window.setTimeout(() => submit.focus({ preventScroll: true }), 600);
    }
  });
}
